import { MainButton, OverlineTitle } from '@repo/ui';
import { CpfInput, TelPhone } from 'adasi_components';
import { FormikValues } from 'formik';
import { PersonForm } from 'presentation/app/modules/Person/components/person-form';
import { PersonFormActions } from 'presentation/app/modules/Person/components/person-form/person-form-actions';
import { genderOptions } from 'presentation/app/modules/Person/utils/select-options';
import { Col, Label, Row } from 'reactstrap';

interface IPersonEditFormSubTab {
  validation: FormikValues;
  isLoading: boolean;
}

export const PersonEditFormSubTab = ({
  validation,
  isLoading,
}: IPersonEditFormSubTab) => {
  return (
    <PersonForm.Root onSubmit={validation.handleSubmit}>
      <Row className="g-3">
        <div>
          <OverlineTitle title="Dados Principais" />
        </div>

        <Col md={4}>
          <Label htmlFor="cpf" className="form-label">
            CPF
          </Label>
          <CpfInput
            disabled
            name="cpf"
            inputId="cpf"
            className="form-control"
            value={validation.values.cpf}
            handleChange={validation.handleChange}
          />
        </Col>

        <PersonForm.Input
          md={8}
          name="name"
          type="text"
          label="Nome"
          validation={validation}
        />

        <PersonForm.Input
          md={6}
          name="socialName"
          type="text"
          label="Nome Social"
          validation={validation}
        />

        <PersonForm.Input
          md={2}
          name="rg"
          type="text"
          label="RG"
          validation={validation}
        />

        <PersonForm.Input
          md={2}
          name="birth"
          type="date"
          label="Nascimento"
          validation={validation}
        />

        <PersonForm.Select
          isClearable
          md={2}
          label="Sexo"
          name="gender"
          options={genderOptions}
          validation={validation}
        />

        <div>
          <OverlineTitle title="Contatos" />
        </div>

        <Col md={4}>
          <Label htmlFor="phone" className="form-label">
            Telefone
          </Label>
          <TelPhone
            id="phone"
            name="phone"
            value={`${validation.values.phone}`}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const inputValue = {
                target: {
                  name: 'phone',
                  value: e,
                },
              };
              validation.handleChange(inputValue);
            }}
            onBlur={validation.handleBlur}
          />
        </Col>

        <PersonForm.Input
          md={4}
          name="email"
          type="email"
          label="E-mail"
          validation={validation}
        />

        <div>
          <OverlineTitle title="Endereço" />
        </div>
        <PersonForm.AddressFields validation={validation} />

        <PersonFormActions>
          <MainButton type="submit" color="primary" isLoading={isLoading}>
            Salvar
          </MainButton>
        </PersonFormActions>
      </Row>
    </PersonForm.Root>
  );
};
